import React from "react";
import { cls } from "cls";
import { EventHeroModel } from "../Models/PageCreatorPage";
import HeroCountdown from "./HeroCountdown";
import ChildOrNull from "~/common/ChildOrNull";

export interface EventHeroProps extends EventHeroModel {
  isItemListingPage: boolean;
  activeStartDate: string;
  activeEndDate: string;
}

const EventHero = ({
  backgroundImageUrl,
  countdownCta,
  couponCode,
  couponCodeTextColor,
  titleImageAltText,
  titleImageUrl,
  activeStartDate,
  activeEndDate,
}: EventHeroProps) => {
  return (
    <div
      className={cls(
        "bg-top",
        "bg-no-repeat",
        "bg-cover",
        "overflow-hidden",
        "relative",
        "lt:-mt-6",
      )}
      style={{ backgroundImage: `url("${backgroundImageUrl}")` }}
    >
      <div className={cls("flex", "flex-col", "relative")}>
        <div
          className={cls(
            "flex",
            "flex-col",
            "gap-4",
            "mt-0",
            "px-4",
            "pt-10",
            "pb-12",
            "w-auto",
            "sm:px-8",
          )}
        >
          <img
            src={titleImageUrl}
            alt={titleImageAltText}
            className={`${cls("mx-auto", "w-full", "lg:w-auto")} max-w-[840px]`}
            aria-hidden="true"
          />
          <ChildOrNull condition={couponCode.length > 0 || !!countdownCta}>
            <div
              className={cls(
                "flex",
                "flex-wrap",
                "items-center",
                "justify-center",
                "gap-4",
                "px-8",
                "sm:gap-8",
              )}
            >
              <ChildOrNull condition={couponCode.length > 0}>
                <p
                  style={{
                    color: couponCodeTextColor,
                    border: `2px solid ${couponCodeTextColor}`,
                  }}
                  className={cls(
                    "font-semibold",
                    "text-xl",
                    "leading-none",
                    "m-0",
                    "text-center",
                    "px-6",
                    "py-3",
                    "rounded",
                  )}
                  data-testid="event-hero-coupon-code"
                >
                  Use Code: {couponCode}
                </p>
              </ChildOrNull>
              <HeroCountdown
                customCountdownText={countdownCta}
                eventStartDate={activeStartDate}
                eventEndDate={activeEndDate}
                textColor={couponCodeTextColor}
              />
            </div>
          </ChildOrNull>
        </div>
      </div>
    </div>
  );
};

export default EventHero;
